<template>
    <card>
        <IVRKeys :initial-i-v-r="initialIVR" v-on:button-add="loadInternal"
                 v-on:button-remove="loadInternal"></IVRKeys>
    </card>
</template>

<script>
    import swal from 'sweetalert2';
    import IVRKeys from "../IVR/IVRKeys";

    export default {
        name: "IVRCard",
        components: {
            IVRKeys,
            swal,
        },
        props: {
            initialIVR: Object,
        },
        data() {
            return {
                name: this.initialIVR.name,
                saving: false,
                removing: [],
                loading: false,
            }
        },
        methods: {
            loadInternal() {
                this.isLoading = true;
                this.$store.dispatch('ivr/loadInternal').then(() => {
                    this.isLoading = false;
                })
            },
        }
    }
</script>

<style scoped>

</style>